import { Injectable } from '@angular/core';
import {RaffleCategoryMetadata} from '@core/models/raffle.model';
import {RootPathCheckerService as RootPathCheckerServiceBase} from '@core/services/root-path-checker/root-path-checker.service';

@Injectable({
  providedIn: 'root'
})
export class RootPathCheckerService extends RootPathCheckerServiceBase {

  getRaffleCategoryMetadataList(): RaffleCategoryMetadata[] {
    return [
      this.getCompetitionsMetadata('All Competitions', 'competitions', 'date', 'white', false, true, false),
      this.getCompetitionsMetadata('Upcoming Competitions', 'upcoming-competitions', null, 'white', false, true, false),
      this.getCompetitionsMetadata('Ending Soonest', 'ending-soon', null, 'white', false, true, false, 'date'),
      this.getCompetitionsMetadata('Today’s Competitions!', 'todays-competitions', 'today-only', 'white'),
      this.getCompetitionsMetadata('App Exclusives', 'app-only', 'app-only', 'white'),
      this.getCompetitionsMetadata('Tomorrow’s Competitions!', 'tomorrows-competitions', 'tomorrow-only', 'white'),
      this.getCompetitionsMetadata('Just Launched', 'just-launched', 'launched', 'white'),
      this.getCompetitionsMetadata('Monday Draws', 'monday-draws', 'monday-only', 'white'),
      this.getCompetitionsMetadata('Tuesday Draws', 'tuesday-draws', 'tuesday-only', 'white'),
      this.getCompetitionsMetadata('Wednesday Draws', 'wednesday-draws', 'wednesday-only', 'white'),
      this.getCompetitionsMetadata('Thursday Draws', 'thursday-draws', 'thursday-only', 'white'),
      this.getCompetitionsMetadata('Friday Draws', 'friday-draws', 'friday-only', 'white'),
      this.getCompetitionsMetadata('Saturday Draws', 'saturday-draws', 'saturday-only', 'white'),
      this.getCompetitionsMetadata('Sunday Draws', 'sunday-draws', 'sunday-only', 'white'),
    ];
  }

}
